import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { Box, LinearProgress } from "@mui/material";

const NavigationFeedbackContext = createContext(null);

export const NavigationFeedbackProvider = ({ children }) => {
  const [isNavigating, setIsNavigating] = useState(false);
  const startNavigation = useCallback(() => setIsNavigating(true), []);
  const finishNavigation = useCallback(() => setIsNavigating(false), []);

  const value = useMemo(
    () => ({
      isNavigating,
      startNavigation,
      finishNavigation,
    }),
    [finishNavigation, isNavigating, startNavigation],
  );

  return (
    <NavigationFeedbackContext.Provider value={value}>
      {isNavigating && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2000,
          }}
        >
          <LinearProgress color="success" />
        </Box>
      )}
      {children}
    </NavigationFeedbackContext.Provider>
  );
};

export const useNavigationFeedback = () => {
  const context = useContext(NavigationFeedbackContext);

  if (!context) {
    throw new Error(
      "useNavigationFeedback must be used within NavigationFeedbackProvider",
    );
  }

  return context;
};
